import React, {FC, HTMLAttributes} from "react"
import styled from "styled-components"


const StyledFlexDiv = styled.div`
    display: flex;
    flex: 1 1 0px
    flex-direction: row;
    flex-wrap: wrap;
    gap: 20px 35px;
`;

const FlexDiv: FC<HTMLAttributes<HTMLDivElement>> = (props) => <StyledFlexDiv {...props} />

export default FlexDiv